export const dashboardButtonHook = 'dashboard-button';
